import React from "react";
import { Modal, ModalBody, Button, Badge } from "reactstrap";
import api from "./../../../Api.js";

/**
 * EventClaim — modal interativo de evento resgatavel (bau / pergunta relampago).
 * - chest: os 3 primeiros a abrir levam o premio.
 * - lightning_question: o primeiro a acertar leva tudo.
 */
class EventClaim extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      details: null,
      loading: true,
      claiming: false,
      result: null,      // sucesso {claimed:true, goldGained, xpGained}
      errorMsg: null,    // 409/410/400 — mensagem final (sem retry)
      shaking: false,    // errou a relampago (retry permitido)
      wrongMsg: null
    };
    this.closeTimer = null;
    this.retryTimer = null;
  }

  async componentDidMount() {
    await this.loadDetails();
  }

  componentWillUnmount() {
    if (this.closeTimer) clearTimeout(this.closeTimer);
    if (this.retryTimer) clearTimeout(this.retryTimer);
  }

  async loadDetails() {
    var event = this.props.event;
    if (!event || !event.id) { this.setState({ loading: false }); return; }
    try {
      var res = await api.getEventDetails(event.id);
      var details = res.data || {};
      var errorMsg = null;
      if (details.alreadyClaimed) {
        errorMsg = event.type === 'chest'
          ? 'Você já abriu esse baú!'
          : 'Você já participou desse evento!';
      }
      this.setState({ details: details, loading: false, errorMsg: errorMsg });
    } catch (e) {
      var status = e.response && e.response.status;
      this.setState({
        loading: false,
        errorMsg: status === 410
          ? (this.props.event.type === 'chest' ? 'Tarde demais! O baú já foi saqueado 😢' : 'Alguém foi mais rápido! 😭')
          : 'Não deu pra carregar o evento... tenta de novo!'
      });
    }
  }

  async claim(answerIndex) {
    if (this.state.claiming || this.state.result) return;
    var event = this.props.event;
    this.setState({ claiming: true, wrongMsg: null, shaking: false });
    try {
      var res = await api.claimEvent(event.id, answerIndex !== undefined ? { answerIndex: answerIndex } : undefined);
      var result = res.data || {};

      if (result.claimed) {
        // Ganhou! Mostra feedback e fecha em 2.5s
        var self = this;
        this.setState({ result: result });
        this.closeTimer = setTimeout(() => {
          if (self.props.onClaimed) self.props.onClaimed(result);
        }, 2500);
      } else {
        // Errou a pergunta relampago — shake e permite tentar de novo
        var self2 = this;
        this.setState({ shaking: true, wrongMsg: result.message || 'Errou! Ainda dá tempo...' });
        this.retryTimer = setTimeout(() => {
          self2.setState({ claiming: false, shaking: false });
        }, 1500);
      }
    } catch (e) {
      var status = e.response && e.response.status;
      var errorMsg;
      if (status === 409) {
        errorMsg = event.type === 'chest' ? 'Você já abriu esse baú!' : 'Você já participou desse evento!';
      } else if (status === 410) {
        errorMsg = event.type === 'chest' ? 'Tarde demais! O baú já foi saqueado 😢' : 'Alguém foi mais rápido! 😭';
      } else {
        errorMsg = (e.response && e.response.data && e.response.data.error) || 'Falha ao resgatar o evento... tenta de novo!';
      }
      this.setState({ claiming: false, errorMsg: errorMsg });
    }
  }

  renderClose() {
    // X pra fechar — some durante o feedback de sucesso
    if (this.state.result) return null;
    return (
      <button
        type="button"
        onClick={() => this.props.onClose && this.props.onClose()}
        style={{
          position: 'absolute',
          top: '10px',
          right: '15px',
          background: 'rgba(0,0,0,0.25)',
          border: 'none',
          borderRadius: '50%',
          width: '32px',
          height: '32px',
          color: '#fff',
          fontSize: '1rem',
          cursor: 'pointer',
          zIndex: 10
        }}
        aria-label="Fechar"
      >
        <i className="fas fa-times" />
      </button>
    );
  }

  renderSuccess() {
    var result = this.state.result;
    var isChest = this.props.event.type === 'chest';
    return (
      <div className="text-center" style={{ padding: '35px 20px', animation: 'popIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)' }}>
        <div style={{ fontSize: '4rem' }}>{isChest ? '🎉' : '🏆'}</div>
        <h3 style={{ fontWeight: 800 }}>
          {isChest ? 'BAÚ ABERTO!' : 'VOCÊ LEVOU O PRÊMIO!'}
        </h3>
        <h2 style={{ fontWeight: 800, color: '#fb6340' }}>
          +{result.goldGained || 0} 🪙 · +{result.xpGained || 0} XP
        </h2>
      </div>
    );
  }

  renderError() {
    return (
      <div className="text-center" style={{ padding: '35px 20px' }}>
        <div style={{ fontSize: '3.5rem' }}>😢</div>
        <h4 className="mb-3">{this.state.errorMsg}</h4>
        <Button color="secondary" onClick={() => this.props.onClose && this.props.onClose()}>
          Fechar
        </Button>
      </div>
    );
  }

  renderChest() {
    var details = this.state.details;
    var rewards = (details && details.rewards) || this.props.event.rewards || {};
    var maxClaimers = rewards.maxClaimers || 3;
    var claimedCount = Math.max(
      this.props.claimedCount || 0,
      (details && details.claimedCount) || 0
    );

    return (
      <div className="text-center" style={{ padding: '25px 20px' }}>
        <p className="text-muted mb-3">
          {this.props.event.description || 'Um baú misterioso apareceu na sala!'}
        </p>
        <h5 className="mb-3">⚡ Os {maxClaimers} primeiros a abrir levam o prêmio!</h5>

        <Badge color="warning" pill style={{ fontSize: '0.9rem', padding: '8px 16px' }} className="mb-3">
          <i className="fas fa-users mr-1" />
          {claimedCount}/{maxClaimers} já abriram
        </Badge>

        {(rewards.gold || rewards.xp) ? (
          <p className="mb-3">
            Dentro do baú: <strong>+{rewards.gold || 0} 🪙</strong> · <strong>+{rewards.xp || 0} XP</strong>
          </p>
        ) : null}

        <Button
          color="warning"
          size="lg"
          block
          onClick={() => this.claim()}
          disabled={this.state.claiming}
          style={{ fontWeight: 800, fontSize: '1.3rem', padding: '15px' }}
        >
          {this.state.claiming
            ? <span><i className="fas fa-spinner fa-spin mr-2" />Abrindo...</span>
            : '🗝️ ABRIR O BAÚ!'}
        </Button>
      </div>
    );
  }

  renderLightning() {
    var details = this.state.details;
    var question = details && details.question;
    var rewards = (details && details.rewards) || this.props.event.rewards || {};

    return (
      <div style={{ padding: '25px 20px' }}>
        {this.state.wrongMsg && (
          <div className="alert alert-danger text-center mb-3">
            <i className="fas fa-times-circle fa-2x mb-1" />
            <h5 className="mb-0">{this.state.wrongMsg}</h5>
          </div>
        )}

        {question ? (
          <React.Fragment>
            <h4 className="mb-4 text-center" style={{
              background: '#f8f9fa',
              padding: '20px',
              borderRadius: '8px',
              borderLeft: '4px solid #9C27B0'
            }}>
              ⚡ {question.question}
            </h4>
            {question.options && question.options.map((opt, idx) => (
              <Button
                key={idx}
                color="primary"
                block
                size="lg"
                className="mb-2 text-left"
                onClick={() => this.claim(idx)}
                disabled={this.state.claiming}
                style={{ padding: '15px 20px' }}
              >
                <strong>{String.fromCharCode(65 + idx)})</strong> {opt}
              </Button>
            ))}
            <p className="text-center text-muted mt-3 mb-0">
              <small>Prêmio pro primeiro que acertar: <strong>+{rewards.gold || 0} 🪙 · +{rewards.xp || 0} XP</strong></small>
            </p>
          </React.Fragment>
        ) : (
          <p className="text-center text-muted mb-0">Carregando a pergunta...</p>
        )}
      </div>
    );
  }

  render() {
    var event = this.props.event;
    if (!event) return null;

    var isChest = event.type === 'chest';
    var headerBg = isChest
      ? 'linear-gradient(135deg, #FFD700 0%, #FF8C00 100%)'
      : 'linear-gradient(135deg, #9C27B0 0%, #FFD700 140%)';

    return (
      <Modal isOpen={true} backdrop="static" centered>
        <ModalBody style={{ padding: 0, overflow: 'hidden', position: 'relative' }}>
          {this.renderClose()}

          {/* Header do evento */}
          <div style={{
            background: headerBg,
            padding: '25px 20px',
            color: '#fff',
            textAlign: 'center',
            textShadow: '0 2px 4px rgba(0,0,0,0.3)',
            animation: this.state.shaking ? 'shake 0.5s' : 'none'
          }}>
            <div style={{ fontSize: '4.5rem', lineHeight: 1, filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))' }}>
              {isChest ? '🎁' : '⚡'}
            </div>
            <h2 style={{ margin: '10px 0 0', fontWeight: 800, color: '#fff' }}>
              {event.title || (isChest ? 'Baú Surpresa!' : 'Pergunta Relâmpago!')}
            </h2>
            <small style={{ opacity: 0.9, textTransform: 'uppercase', letterSpacing: '2px' }}>
              {isChest ? 'EVENTO · BAÚ' : 'EVENTO · RELÂMPAGO'}
            </small>
          </div>

          {/* Corpo */}
          {this.state.loading ? (
            <div className="text-center" style={{ padding: '35px 20px' }}>
              <i className="fas fa-spinner fa-spin fa-2x text-muted" />
            </div>
          ) : this.state.result ? (
            this.renderSuccess()
          ) : this.state.errorMsg ? (
            this.renderError()
          ) : isChest ? (
            this.renderChest()
          ) : (
            this.renderLightning()
          )}

          <style>{`
            @keyframes shake {
              0%, 100% { transform: translateX(0); }
              25% { transform: translateX(-10px); }
              75% { transform: translateX(10px); }
            }
            @keyframes popIn {
              0% { transform: scale(0.3); opacity: 0; }
              100% { transform: scale(1); opacity: 1; }
            }
          `}</style>
        </ModalBody>
      </Modal>
    );
  }
}

export default EventClaim;
